if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.options = {
        draggable: true,
        slidesPerView: 1,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
      };

      this.slider = new Swiper(this.querySelector('.swiper'), this.options);

      this.slider.on('slideChangeTransitionEnd', (swiper) => {
        const prevSlide = swiper.slides[swiper.previousIndex || 0];
        const activeSlide = swiper.slides[swiper.activeIndex];

        prevSlide.querySelectorAll('video').forEach(video => {
          video.pause();
        });

        activeSlide.querySelectorAll('video').forEach(video => {
          video.play();
        });
      })
    }
  }

  customElements.define('hero-slider', HeroSlider);
}
